import {computed, onBeforeMount, ref} from 'vue';
import {assign, isFunction} from 'lodash-es';
import {useFormValidation} from './useFormValidation';

/**
 * @Author Ken
 * @CreateDate 2021-12-14 16:18
 * @desc create/update model
 * @params
 * @return
 */
export function useModelPost(config = {}) {
  const { router, routerTo, model, getOne, post, successPath } = config;

  const FormValidation = useFormValidation();

  const id = computed(() => router.currentRoute.value.params?.id);
  // const id = computed(() => router.currentRoute.value.params?.id ?? searchObject?.id);
  const isAdd = computed(() => !id.value);
  const isEdit = computed(() => !!id.value);
  const loading = ref(false);

  if (isFunction(getOne) && model) {
    onBeforeMount(async () => {
      if (isEdit.value) {
        loading.value = true;
        let data;
        try {
          data = await getOne(id.value);
          assign(model, data);
        } finally {
          loading.value = false;
        }
      }
    });
  }

  async function onPost(params) {
    await FormValidation.validate();

    let ret = null;
    loading.value = true;
    try {
      ret = await post(params ?? model);
    } finally {
      loading.value = false;
    }

    successPath && routerTo(successPath);
    return ret;
  }

  return {
    id,
    isAdd,
    isEdit,
    loading,
    onPost,
    ...FormValidation,
  };
}
